import { SortOrder } from '../../common/types';
import { ConfigurationItem } from '../../parser/ParserTypes';
import { translateSortKeyToConfigurationProp } from './utils';

function isValidDate(dateString: string) {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

export const sortByProperty = (
  array: ConfigurationItem[],
  _sortKey: string,
  sortDirection: SortOrder,
) => {
  const sortKey = translateSortKeyToConfigurationProp(_sortKey);

  // Ensure we have a valid array and create a copy for sorting
  const safeArray = Array.isArray(array) ? array : [];

  return safeArray.slice().sort((a, b) => {
    const getValue = (obj: any) => sortKey.split('.').reduce((o, p) => o && o[p], obj);

    const valueA = getValue(a);
    const valueB = getValue(b);

    let comparison = 0;

    if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
      comparison = valueA < valueB ? -1 : 1;
    } else if (isValidDate(valueA) && isValidDate(valueB)) {
      comparison = new Date(valueA).getTime() - new Date(valueB).getTime();
    } else if (typeof valueA === 'number' && typeof valueB === 'number') {
      comparison = valueA - valueB;
    } else if (typeof valueA === 'string' && typeof valueB === 'string') {
      comparison = valueA.toLowerCase() < valueB.toLowerCase() ? -1 : 1;
    } else {
      comparison = valueA < valueB ? -1 : 1;
    }

    return sortDirection === SortOrder.DESC ? comparison * -1 : comparison;
  });
};
